import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppShellPage } from './pages/app-shell/app-shell.page';
import { CampaignsPage } from './pages/campaigns/campaigns.page';
import { ContactsPage } from './pages/contacts/contacts.page';
import { DashboardPage } from './pages/dashboard/dashboard.page';
import { LoginPage } from './pages/login/login.page';
import { MetaCallbackPage } from './pages/meta-callback/meta-callback.page';
import { RegisterPage } from './pages/register/register.page';
import { SetupWizardPage } from './pages/setup-wizard/setup-wizard.page';
import { TemplatesPage } from './pages/templates/templates.page';

@NgModule({
  declarations: [
    AppComponent,
    AppShellPage,
    LoginPage,
    MetaCallbackPage,
    RegisterPage,
    DashboardPage,
    SetupWizardPage,
    ContactsPage,
    TemplatesPage,
    CampaignsPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
